/**
 * Guided product tour (QA F4).
 *
 * - Steps, roles and the state machine: `src/tour/tourModel.ts` (pure).
 * - State, auto-start and persistence: `src/context/TutorialContext.tsx`.
 * - Overlay: `TutorialLayer` (placed once in the root layout).
 * - Targets are stable `testID`s on the real elements.
 */
export { TutorialLayer } from './TutorialLayer';
export { InfoHint } from './InfoHint';

export {
  useTutorial,
  useTutorialStep,
  TutorialProvider,
} from '../../context/TutorialContext';
